import React from 'react';

//Componentes auxiliares: 
import HyperlinkLabel from './HyperlinkLabel';
import OptionsDropwdown from './OptionsDropwdown';
import ExecuteScratchButton from './ExecuteScratchButton';
import ButtonWithStatusModal from './ButtonWithStatusModal';

//Scripts auxiliares:
import { getSourceTitleText, getSourceSubtitleText, getDataValidityPeriod } from '../../../views/common/downloadSourcesRenderingFunctions';
let dateFormatter = require('../../../tools/formatters/dateFormatter');

//Estilos base:
let paragraphBaseStyle = {
    textTransform: "none", marginBottom: 0,
    paddingTop: 5
};

function DownloadSourceResumeRow(props) {
    return (
        <tr>
            <td>
                <p style={{ marginBottom: 0 }}>
                    <b>{getSourceTitleText(props.downloadSource.description)}</b>
                    {getSourceSubtitleText(props.downloadSource.description)}
                </p>
                <HyperlinkLabel urlTarget={props.getScratchUrl(props.downloadSource)} />
            </td>
            <td>
                <ButtonWithStatusModal context="última descarga"
                    downloadSource={props.downloadSource}
                    getStatusIconClassname={props.getStatusIconClassname}
                    getDownloadSourceTitle={props.getDownloadSourceTitle}
                    targetProcess={props.downloadSource.source_process[0]}
                    getStatusButtonClassname={props.getStatusButtonClassname}
                    getTimelineDivClassname={props.getTimelineDivClassname}
                    getTimelineIconClassname={props.getTimelineIconClassname}
                    cancelDownloadProcess={props.cancelDownloadProcess}
                    retryDownloadProcess={props.retryDownloadProcess}>

                    <button className={props.getStatusButtonClassname(props.downloadSource)}
                        style={{ padding: "8px 15px", width: 125 }} title="Detalle de la descarga">
                        {props.getDownloadSourceTitle(props.downloadSource)}
                    </button>
                </ButtonWithStatusModal>

                {getErrorDateLabel(props.downloadSource)}
                {getCancelDateLabel(props.downloadSource)}
                {getFinishDateLabel(props.downloadSource)}
                {getRemainingTimeLabel(props.downloadSource)}

            </td>

            <td>
                {getStartDateLabel(props.downloadSource)}
            </td>

            <td>
                {getNextDownloadDateLabel(props.downloadSource)}
            </td>

            <td className="">
                <ExecuteScratchButton downloadSource={props.downloadSource}
                    onClick={props.executeScratchOnClick} />
            </td>
            <td className="">
                <OptionsDropwdown
                    downloadSource={props.downloadSource}
                    reloadSourcesMethod={props.reloadSourcesMethod} />
            </td>
        </tr>
    );
}

function getCancelDateLabel(downloadSource) {
    if (downloadSource.status === "CANCELLED") {
        if (downloadSource.source_process.length > 0) {
            let targetDate = dateFormatter.getShortDate(new Date(downloadSource.source_process[0].end_date || downloadSource.source_process[0].modified)) + " " +
                dateFormatter.getShortHour(new Date(downloadSource.source_process[0].end_date || downloadSource.source_process[0].modified));

            return (
                <p className="category" style={{ ...paragraphBaseStyle, width:125 }} title={"Cancelado en: " + targetDate}
                    dangerouslySetInnerHTML={{ __html: "<b>cnl</b>: " + targetDate }}>
                </p>
            );
        }
    }
}

function getErrorDateLabel(downloadSource) {
    if (downloadSource.status === "ERROR") {
        if (downloadSource.source_process.length > 0) {
            let targetDate = dateFormatter.getShortDate(new Date(downloadSource.source_process[0].end_date)) + " " +
                dateFormatter.getShortHour(new Date(downloadSource.source_process[0].end_date));

            return (
                <p className="category" style={{ ...paragraphBaseStyle, width:125 }} title={"Error presentado en: " + targetDate}
                    dangerouslySetInnerHTML={{ __html: "<b>error</b>: " + targetDate }} ></p>
            );
        }
    }
}

function getMessageForDataPeriod(downloadSource) {
    if (downloadSource.source_process[0]) {
        return (
            <p className="category" style={{ ...paragraphBaseStyle, paddingLeft: 0 }}>
                <b>Periodo: </b>
                <span>
                    {getDataValidityPeriod(downloadSource.source_process[0])}
                </span>
            </p>
        );
    }
    else {
        return (
            <span>{"-"}</span>
        );
    }
}

function getNextDownloadDateLabel(downloadSource) {
    let nextExecutionDate = downloadSource.next_execution_date;

    let nextDateLabel = "-";
    if (nextExecutionDate) { nextDateLabel = dateFormatter.getShortDate(new Date(nextExecutionDate)); }

    let nextHourLabel = "-";
    if (nextExecutionDate) { nextHourLabel = dateFormatter.getShortHour(new Date(nextExecutionDate)); }

    return (
        <React.Fragment>
            <p style={{ marginBottom: 0, paddingLeft: 0 }}>
                {nextDateLabel}
            </p>
            <p className="category" style={{ ...paragraphBaseStyle, paddingLeft: 0 }}>
                {nextHourLabel}
            </p>
        </React.Fragment>
    );
}

function getFinishDateLabel(downloadSource) {
    if (downloadSource.status === "SUCCESS" || downloadSource.status === "WARNING") {
        if (downloadSource.source_process.length > 0) {
            let targetDate = dateFormatter.getShortDate(new Date(downloadSource.source_process[0].end_date || downloadSource.source_process[0].modified)) + " " +
                dateFormatter.getShortHour(new Date(downloadSource.source_process[0].end_date || downloadSource.source_process[0].modified));

            return (
                <p className="category" style={{ ...paragraphBaseStyle, width:125 }} title={"Finalizado en: " + targetDate}
                    dangerouslySetInnerHTML={{ __html: "<b>fin</b>: " + targetDate }}>
                </p>
            );
        }
    }
}

function getRemainingTimeLabel(downloadSource) {
    // if (downloadSource.status === "IN_PROCESS") {
    //     if (downloadSource.source_process.length > 0) {
    //         let remainingEstimatedTime = dateFormatter.getDatesInterval(new Date(), new Date(downloadSource.source_process[0].end_date));
    //         remainingEstimatedTime = remainingEstimatedTime.replace("<b>", "");
    //         remainingEstimatedTime = remainingEstimatedTime.replace("</b>", "");

    //         return (
    //             <p className="category" style={{ ...paragraphBaseStyle, width:125}} title={"Finalización estimada en: " + remainingEstimatedTime}
    //                 dangerouslySetInnerHTML={{ __html: "<b>est</b>: " + remainingEstimatedTime }}></p>
    //         );
    //     }
    // }

    return (<React.Fragment />);
}

function getStartDateLabel(downloadSource) {
    let outMessageForDate = "-";
    let outMessageForHour = "-";
    
    if (downloadSource.source_process.length > 0) {
        outMessageForDate = dateFormatter.getShortDate(new Date(downloadSource.source_process[0].created));
        outMessageForHour = dateFormatter.getShortHour(new Date(downloadSource.source_process[0].created));
    }

    return (
        <React.Fragment>
            <p style={{ marginBottom: 0, paddingLeft: 0 }}>
                {outMessageForDate}
            </p>
            <p className="category" style={{ ...paragraphBaseStyle, paddingLeft: 0 }}>
                {outMessageForHour}
            </p>

            {getMessageForDataPeriod(downloadSource)}
        </React.Fragment>
    );
}

export default DownloadSourceResumeRow;